var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventario-panel-row"},[_c('h4',{staticClass:"inventario-panel-subtitle"},[_vm._v(_vm._s(_vm.row.name))]),_c('CDataTable',{attrs:{"hover":"","bordered":"","small":"","fixed":"","loading":_vm.isLoading,"items":_vm.items,"fields":_vm.fields},scopedSlots:_vm._u([{key:"over-table",fn:function(){return [_c('CRow',{})]},proxy:true},{key:"folio-header",fn:function(){return [_c('div',{staticClass:"d-flex flex-row"},[_c('span',{staticClass:"align-self-center"},[_vm._v("Folio")])])]},proxy:true},{key:"folio",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2"},[_vm._v(" "+_vm._s(item.folio)+" ")])]}},{key:"ubicacion_raiz_id",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2"},[_vm._v(" "+_vm._s(item._relaciones.ubicacion_raiz.payload.nombre)+" ")])]}},{key:"actividad_id",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2"},[_vm._v(" "+_vm._s(item._relaciones.actividad.payload.nombre)+" ")])]}},{key:"trabajador_id",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2"},[_vm._v(" "+_vm._s(item._relaciones.trabajador.payload.nombre)+" ")])]}},{key:"cantidad_costo",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2 text-right"},[_vm._v(" "+_vm._s(_vm.$formatter(item.cantidad_costo, 0, ".00"))+" ")])]}},{key:"monto",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2 text-right"},[_vm._v(" "+_vm._s(_vm.$formatter(item.monto, 1))+" ")])]}},{key:"costo_unitario",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2 text-right"},[_vm._v(" "+_vm._s(_vm.$formatter(item.costo_unitario, 1))+" ")])]}},{key:"total",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2 text-right"},[_vm._v(" "+_vm._s(_vm.$formatter(item.cantidad_costo * item.costo_unitario, 1))+" ")])]}},{key:"data",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2"},[_vm._v(" "+_vm._s(Object.keys(item))+" "),_c('br'),_vm._v(" "+_vm._s(Object.keys(item._relaciones))+" ")])]}},{key:"ver",fn:function(ref){
var item = ref.item;
return [_c('td',{staticClass:"py-2"},[_c('router-link',{attrs:{"to":{
            name: _vm.row.view,
            params: {
              id: item.folio,
              folio: item.folio,
              goBack: {
                name: 'VerCalculoAdministrativo',
                params: {
                  id: _vm.folio
                }
              }
            }
          }}},[_c('CButton',{attrs:{"color":"success","square":"","size":"sm"}},[_vm._v("Ver")])],1)],1)]}},{key:"under-table",fn:function(){return [_c('div',{staticClass:"footer-table"})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }